import { post, put } from './index';

export const getNotifications = ({ filters }) => {
  return post('/api/v1/notifications', filters);
};

export const markNotificationAsRead = ({ notificationId }) => {
  return put(`/api/v1/notifications/${notificationId}/read`);
};

export const markAllNotificationsAsRead = () => {
  return put('/api/v1/notifications/read');
};
